module.exports = __webpack_public_path__ + "static/media/15_DEI_Bonnie Wong.0510fc38.jpeg";